import 'core-js/modules/es.promise.js';
import { __awaiter } from '../../_virtual/_tslib.js';
import { MediaUploadDefaultError } from '../domain/errors/media-upload-default.js';
import { GetUploadErrorMessage } from './get-upload-error-message.js';

class UploadAssetBySignedUrl {
  execute(input) {
    return __awaiter(this, void 0, void 0, function* () {
      try {
        return new Promise((resolve, reject) => {
          // TODO: Refactor to use HttpClient
          const xhr = new XMLHttpRequest();
          xhr.open('PUT', input.writeUrl, true);
          xhr.upload.onprogress = function (progress) {
            input.onUploadProgress(progress.loaded / progress.total * 100);
          };
          xhr.upload.onloadend = function (progress) {
            if (progress.lengthComputable) {
              input.onUploadProgress(progress.loaded / progress.total * 100);
            }
          };
          xhr.onload = function () {
            if (xhr.status === 200) {
              resolve(input.asset);
            } else {
              reject(new GetUploadErrorMessage().execute(input.mimeType));
            }
          };
          xhr.onerror = function () {
            reject(new GetUploadErrorMessage().execute(input.mimeType));
          };
          xhr.send(input.file);
        });
      } catch (error) {
        throw new MediaUploadDefaultError();
      }
    });
  }
}

export { UploadAssetBySignedUrl };
